import { Component, Input, ChangeDetectionStrategy, OnChanges, OnInit, ChangeDetectorRef, OnDestroy, Inject } from '@angular/core';
import { groupingOptions, GroupingOptionItem } from './../grouping-selector/grouping-options';
import { GridLegendItem } from '../legend';
import { Subscription } from 'rxjs';
import { DocumentsCounterBase } from './models/documents-counter';
import { Category } from './models/category';
import { UnreadReportsStorage, UNREAD_REPORTS_STORAGE } from './unread-reports-storage';
import { DocumentsColumns, DOCUMENTS_COLUMNS_TOKEN } from './documents-columns/documents-columns';
import { Report } from './models/report';

@Component({
    selector: 'documents-grid',
    template: require('./documents-grid.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [require('./documents-grid.component.scss')]
})
export class DocumentsGridComponent implements OnChanges, OnInit, OnDestroy {
    @Input()
    public allReports: Report[];

    @Input()
    public category: Category;

    @Input()
    public showExport = false;

    public onlyUnread: boolean;
    public reports: Report[];
    public groupBy: GroupingOptionItem;
    public groupOptions: GroupingOptionItem[] = [];
    public groupName = 'group-selector';
    public legend: GridLegendItem[] = [];

    private unreadSubscription: Subscription;

    constructor(
        @Inject(DOCUMENTS_COLUMNS_TOKEN) private categoriesGridColumns: DocumentsColumns,
        @Inject(UNREAD_REPORTS_STORAGE) unreadReportsRegistry: UnreadReportsStorage<DocumentsCounterBase>,
        changeDetector: ChangeDetectorRef
    ) {

        this.unreadSubscription = unreadReportsRegistry.docsHaveBeenRead.subscribe(() => {
            this.createLegend();
            changeDetector.markForCheck();
        });
    }

    public ngOnChanges() {
        if (this.category) {
            this.groupOptions = this.categoriesGridColumns.getGroupedColumns(this.category.categoryId);
        }
        
        this.reports = this.allReports;

        this.filterReports();
        this.createLegend();
    }

    public ngOnInit() {
        this.groupBy = groupingOptions.none;
    }

    public onUnreadSelectorChange(onlyUnread: boolean) {
        this.onlyUnread = onlyUnread;

        this.filterReports();
    }

    public ngOnDestroy() {
        this.unreadSubscription.unsubscribe();
    }

    private filterReports() {
        if (!this.allReports) {
            return;
        }

        if (this.onlyUnread) {
            this.reports = this.allReports.filter(report => !report.isRead);
        } else {
            this.reports = this.allReports;
        }
    }

    private createLegend() {

        this.legend = [];

        if (!this.reports || !this.categoriesGridColumns.hasStatusColumn(this.category.categoryId)) {
            return;
        }

        const anyRead = this.reports.some(r => r.isRead);
        if (anyRead) {
            this.legend.push({ icon: 'done', label: 'document has been read' });
        }
    }
}